import { Layers } from "lucide-react";
import { ProductImage } from "../ProductCard";

export function OrderItemThumb({
  src,
  alt = "",
  backgroundColor,
  className = "h-12 w-12 shrink-0 rounded-xl",
}: {
  src: string | null | undefined;
  alt?: string;
  backgroundColor?: string | null;
  className?: string;
}) {
  return (
    <ProductImage
      src={src ?? null}
      alt={alt}
      backgroundColor={backgroundColor}
      fit="cover"
      className={className}
    />
  );
}

export function OrderItemThumbPlaceholder({ className = "h-12 w-12 shrink-0 rounded-xl" }: { className?: string }) {
  return (
    <div className={`flex items-center justify-center bg-surface-2 text-white/25 ${className}`}>
      <Layers size={16} strokeWidth={1.25} />
    </div>
  );
}
